import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({value, link,onClick,val,styl,  style}) => {
    return (
        <>
            <div>
                <Link to={link} onClick={onClick} className={`${style} max-w-[388px] bg-blue-lightBlue text-Inter font-semibold font-inter flex justify-center items-center h-[56px] text-[20px] text-white`}>{value} <div className={styl}>{val}</div></Link>
            </div>
        </>
    );
}

export default Button;
